import { css } from "styled-components";
import { ctaCursorMixin } from "../mixins";
export const leagueClientSkin = (chroma) => css `
  ${ctaCursorMixin}

  & {
    ${chroma.typography.button}
    margin-top: 20px;
    display: inline-block;
    user-select: none;
    background: ${chroma.palette.grey3};
    color: ${chroma.palette.gold2};
    font-size: 14px;
    box-shadow:
      rgb(1 10 19) 0 0 1px 1px,
      rgb(1 10 19) 0 0 1px 1px inset;
    position: relative;
    box-sizing: border-box;
    white-space: nowrap;
    padding: 5px 1.3em;
    cursor: pointer;
    border: 2px solid ${chroma.palette.gold2};

    :hover:not(.disabled) {
      color: ${chroma.palette.gold1};
      background-image: linear-gradient(rgb(30 35 40) 0%, rgb(30 35 40) 40%, rgb(118 97 51) 140%);
    }
  }
`;
//# sourceMappingURL=index.js.map